const pageNameKey = "configurationManager";

export const configurationManagerPageEn = {
  [pageNameKey]: {
    licenseId: "License ID",
    configurationFile: "Configuration File",
    actions: "Actions",
    licensesHeader: "Licenses and associated configurations",
    renderConfigurationTemplate: "Render configuration template",
    serverType: "Server Type",
    opcUa: "OPC UA",
    ipHost: "IP / Host",
    port: "Port",
    create: "Create",
    download: "Download",
    delete: "Delete",
    genericErrorTitle: "Error while loading the data",
    genericErrorHint: "Please try again later",
    deleteSuccess: "Configuration file deleted successfully",
    deleteError: "Error while deleting the configuration file",
    downloadError: "Error while downloading the configuration",
    ipPort: "IP / Port",
    cancel: "Cancel",
    button: "Refresh",
  },
};

export const configurationManagerPagePtBr = {
  [pageNameKey]: {
    licenseId: "ID da licença",
    configurationFile: "Arquivo de configuração",
    actions: "Ações",
    licensesHeader: "Licenças e configurações associadas",
    renderConfigurationTemplate: "Renderizar modelo de configuração",
    serverType: "Tipo de servidor",
    opcUa: "OPC UA",
    ipHost: "IP / Host",
    port: "Porta",
    create: "Criar",
    download: "Baixar",
    delete: "Excluir",
    genericErrorTitle: "Erro ao carregar os dados",
    genericErrorHint: "Tente novamente mais tarde",
    deleteSuccess: "Arquivo de configuração excluído com sucesso",
    deleteError: "Erro ao excluir o arquivo de configuração",
    downloadError: "Erro ao baixar a configuração",
    ipPort: "IP / Porta",
    cancel: "Cancelar",
    button: "Atualizar",
  },
};

export const configurationManagerPageDe = {
  [pageNameKey]: {
    licenseId: "Lizenz-ID",
    configurationFile: "Konfigurationsdatei",
    actions: "Aktionen",
    licensesHeader: "Lizenzen und zugehörige Konfigurationen",
    renderConfigurationTemplate: "Konfigurationsvorlage rendern",
    serverType: "Servertyp",
    opcUa: "OPC UA",
    ipHost: "IP / Host",
    port: "Port",
    create: "Erstellen",
    download: "Herunterladen",
    delete: "Löschen",
    genericErrorTitle: "Fehler beim Laden der Daten",
    genericErrorHint: "Bitte versuchen Sie es später erneut",
    deleteSuccess: "Konfigurationsdatei erfolgreich gelöscht",
    deleteError: "Fehler beim Löschen der Konfigurationsdatei",
    downloadError: "Fehler beim Herunterladen der Konfiguration",
    ipPort: "IP / Port",
    cancel: "Abbrechen",
    button: "Aktualisieren",
  },
};

export const configurationManagerPageZhHans = {
  [pageNameKey]: {
    licenseId: "许可证 ID",
    configurationFile: "配置文件",
    actions: "操作",
    licensesHeader: "许可证和相关配置",
    renderConfigurationTemplate: "渲染配置模板",
    serverType: "服务器类型",
    opcUa: "OPC UA",
    ipHost: "IP / 主机",
    port: "端口",
    create: "创建",
    download: "下载",
    delete: "删除",
    genericErrorTitle: "加载数据时出错",
    genericErrorHint: "请稍后再试",
    deleteSuccess: "配置文件删除成功",
    deleteError: "删除配置文件时出错",
    downloadError: "下载配置时出错",
    ipPort: "IP / 端口",
    cancel: "取消",
    button: "刷新",
  },
};

export const configurationManagerPageIt = {
  [pageNameKey]: {
    licenseId: "ID licenza",
    configurationFile: "File di configurazione",
    actions: "Azioni",
    licensesHeader: "Licenze e configurazioni associate",
    renderConfigurationTemplate: "Renderizza il modello di configurazione",
    serverType: "Tipo di server",
    opcUa: "OPC UA",
    ipHost: "IP / Host",
    port: "Porta",
    create: "Crea",
    download: "Scarica",
    delete: "Elimina",
    genericErrorTitle: "Errore durante il caricamento dei dati",
    genericErrorHint: "Riprova più tardi",
    deleteSuccess: "File di configurazione eliminato correttamente",
    deleteError: "Errore durante l'eliminazione del file di configurazione",
    downloadError: "Errore durante il download della configurazione",
    ipPort: "IP / Porta",
    cancel: "Annulla",
    button: "Aggiorna",
  },
};

export const configurationManagerPageEs = {
  [pageNameKey]: {
    licenseId: "Licencia ID",
    configurationFile: "Archivo de configuración",
    actions: "Acciones",
    licensesHeader: "Licencias y configuraciones asociadas",
    renderConfigurationTemplate: "Renderizar plantilla de configuración",
    serverType: "Tipo de servidor",
    opcUa: "OPC UA",
    ipHost: "IP / Host",
    port: "Puerto",
    create: "Crear",
    download: "Descargar",
    delete: "Eliminar",
    genericErrorTitle: "Error al cargar los datos",
    genericErrorHint: "Por favor, inténtalo de nuevo más tarde",
    deleteSuccess: "Archivo de configuración eliminado correctamente",
    deleteError: "Error al eliminar el archivo de configuración",
    downloadError: "Error al descargar la configuración",
    ipPort: "IP / Puerto",
    cancel: "Cancelar",
    button: "Actualizar",
  },
};

export const configurationManagerPageNl = {
  [pageNameKey]: {
    licenseId: "Licentie-ID",
    configurationFile: "Configuratiebestand",
    actions: "Acties",
    licensesHeader: "Licenties en bijbehorende configuraties",
    renderConfigurationTemplate: "Configuratiesjabloon weergeven",
    serverType: "Servertype",
    opcUa: "OPC UA",
    ipHost: "IP / Host",
    port: "Poort",
    create: "Aanmaken",
    download: "Downloaden",
    delete: "Verwijderen",
    genericErrorTitle: "Fout bij het laden van de gegevens",
    genericErrorHint: "Probeer het later opnieuw",
    deleteSuccess: "Configuratiebestand succesvol verwijderd",
    deleteError: "Fout bij het verwijderen van het configuratiebestand",
    downloadError: "Fout bij het downloaden van de configuratie",
    ipPort: "IP / Poort",
    cancel: "Annuleren",
    button: "Vernieuwen",
  },
};

export const configurationManagerPageTr = {
  [pageNameKey]: {
    actions: "Eylemler",
    button: "Yenile",
    cancel: "İptal etmek",
    configurationFile: "Yapılandırma Dosyası",
    create: "Yaratmak",
    delete: "Silmek",
    deleteError: "Yapılandırma dosyasını silerken hata oluştu",
    deleteSuccess: "Yapılandırma dosyası başarıyla silindi",
    download: "İndirmek",
    downloadError: "Yapılandırma indirilirken hata oluştu",
    genericErrorHint: "Lütfen daha sonra tekrar deneyin",
    genericErrorTitle: "Veriler yüklenirken hata oluştu",
    ipHost: "IP / Ana Bilgisayar",
    ipPort: "IP / Bağlantı Noktası",
    licenseId: "Lisans Kimliği",
    licensesHeader: "Lisanslar ve ilgili yapılandırmalar",
    opcUa: "OPC UA",
    port: "Liman",
    renderConfigurationTemplate: "Yapılandırma şablonunu oluştur",
    serverType: "Sunucu Türü",
  },
};
